import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function VerificaEmail() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/auth/verify-email/${token}`);
        setState("ok"); setMessage(data.message || "Email confermata.");
      } catch (e) {
        setState("error");
        const detail = e.response?.data?.detail;
        setMessage(typeof detail === "string" ? detail : "Link non valido o scaduto.");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="verify-email-page">
      <div className="container-vv max-w-lg text-center py-16">
        {state === "loading" && (
          <>
            <Loader2 className="mx-auto h-12 w-12 text-[#FF6100] animate-spin" />
            <h1 className="mt-6 font-display font-medium text-3xl">Confermiamo la tua email…</h1>
          </>
        )}
        {state === "ok" && (
          <>
            <div className="mx-auto h-16 w-16 rounded-full bg-[#DDEEE8] flex items-center justify-center">
              <CheckCircle2 className="h-9 w-9 text-[#216B65]" strokeWidth={1.75} />
            </div>
            <h1 className="mt-6 font-display font-medium text-4xl">Email confermata ✨</h1>
            <p className="mt-4 text-[#292522]/75">{message}</p>
            <Link to="/accedi" className="btn-primary mt-8 inline-flex" data-testid="verify-go-login">Accedi</Link>
          </>
        )}
        {state === "error" && (
          <>
            <div className="mx-auto h-16 w-16 rounded-full bg-[#FBE3E3] flex items-center justify-center">
              <XCircle className="h-9 w-9 text-[#B12A2A]" strokeWidth={1.75} />
            </div>
            <h1 className="mt-6 font-display font-medium text-4xl">Non ci siamo</h1>
            <p className="mt-4 text-[#292522]/75">{message}</p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/registrati" className="btn-primary">Registrati di nuovo</Link>
              <Link to="/contatti" className="btn-ghost">Contattaci</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
